import { BaseModule } from '@mc/tangram-core'

export class HotSpot extends BaseModule {
  constructor(options) {
    super(options)
    this.imgStyle = this.formatStyle({
      width: this.valueCalc(this.contentWidth)
    })
    this.data = this.formatData(options.data)
  }

  // 热区组件数据格式化处理
  formatData(data) {
    return data.map(hotItem => {
      // 获取当前热区宽高,用于计算热区相对比例
      const { width: baseWidth } = hotItem
      const sizeScale = this.numFormat(this.contentWidth / baseWidth)
      // 相对比例计算出实际定位
      hotItem.hotData = hotItem?.hotData?.map(data => {
        const fitPosition = {}
        const { left, top, width, height } = data.position
        fitPosition.startX = this.valueCalc(left * sizeScale, {
          returnNumber: true
        })
        fitPosition.endX = this.valueCalc((left + width) * sizeScale, {
          returnNumber: true
        })
        fitPosition.startY = this.valueCalc(top * sizeScale, {
          returnNumber: true
        })
        fitPosition.endY = this.valueCalc((top + height) * sizeScale, {
          returnNumber: true
        })
        return {
          ...data,
          position: fitPosition
        }
      })
      // 依据层级关系进行排序，数组中排在后面的覆盖前面的
      hotItem.hotData.reverse()
      hotItem.hotImageLoaded = false
      return hotItem
    })
  }

  /**
   * @description 保留数字指定小数位数
   * @param {*} value 数值
   * @param {number} [decimalNum=2] 需要保留的小数位数
   * @returns
   * @memberof HotSpot
   */
  numFormat(value, decimalNum = 2) {
    const basicDegree = Math.pow(10, decimalNum)
    return !isNaN(value) && Math.floor(value * basicDegree) / basicDegree
  }

  render() {
    const { id, pageId, data, imgStyle, containerStyle } = this
    return {
      id,
      pageId,
      renderIdentifier: 'img-hotspot',
      data,
      imgStyle,
      containerStyle
    }
  }
}
